import React, { useState } from "react";
import { Paper, Box, Typography, Divider } from "@material-ui/core";
import { useSelector, useDispatch } from "react-redux";
import { useStyles } from "../../../../shared/styles/useStyles";
import { AppState } from "../../../../redux/reducers/rootReducer";
import { SpecialDaysForm } from "./SpecialDaysForm";
import { MyAlert } from "../../../../components/custom/MyAlert";
import {
  setErrorMsg,
  setSuccessMsg,
  uiCloseErrorAlert,
  uiCloseSuccessAlert,
} from "../../../../redux/actions/uiActions";
import { SpecialDay } from "../../../../module/superAdmin/form/SpecialDay";
import { startAddSpecialDay } from "../../../../redux/actions/entitiesActions";
import {SpecialDaysTable} from "./SpecialDaysTable";

export const SpecialDaysSection = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedType, setSelectedType] = useState("");
  const [specialDays, setSpecialDays] = useState<SpecialDay[]>([]);

  const { page, rowsPerPage } = useSelector((state: AppState) => state.pagination);
  const { successAlert, successMsg, errorAlert, errorMsg } = useSelector((state: AppState) => state.ui);

  const handleAdd = async () => {
    if (!selectedDate || !selectedType) {
      dispatch(setErrorMsg("Debe seleccionar una fecha y un tipo de día."));
      return;
    }

    const exists = specialDays.some((d) => d.date === selectedDate && d.type === selectedType);
    if (exists) {
      dispatch(setErrorMsg("Este día ya ha sido agregado."));
      return;
    }

    const newDay: SpecialDay = {
      id: Date.now().toString(),
      date: selectedDate,
      type: selectedType,
    };

    try {
      await dispatch(startAddSpecialDay(newDay));
      setSpecialDays([...specialDays, newDay]);
      setSelectedDate("");
      setSelectedType("");
    } catch {
      dispatch(setErrorMsg("Error al agregar el día especial."));
    }
  };

  return (
    <Paper className={classes.paper}>
      <Box p={3}>
        <Typography variant="h6" gutterBottom align="center">
          Parametrización Días Festivos y Especiales
        </Typography>
        <Divider style={{ marginBottom: "1.5rem" }} />

        <SpecialDaysForm
          selectedDate={selectedDate}
          selectedType={selectedType}
          setSelectedDate={setSelectedDate}
          setSelectedType={setSelectedType}
          specialDays={specialDays}
          setSpecialDays={setSpecialDays}
        />

        <SpecialDaysTable page={page} rowsPerPage={rowsPerPage} />


        <MyAlert
          open={successAlert}
          typeAlert="success"
          message={successMsg ?? ""}
          time={2000}
          handleClose={() => dispatch(uiCloseSuccessAlert())}
        />

        <MyAlert
          open={errorAlert}
          typeAlert="error"
          message={errorMsg ?? ""}
          time={3000}
          handleClose={() => dispatch(uiCloseErrorAlert())}
        />
      </Box>
    </Paper>
  );
};
